<template>
  <div class="row">
    <div class="course-content-editor-container small-12 columns">
      <div
        class="close-button absolute cursor-pointer"
        title="Close (Esc)"
        @click="$emit('CLOSE_MODAL')"
      >
        ❌
      </div>
      <div class="small-12 columns">
        <h2>{{ moduleName }}/ {{ topicName }}</h2>
        <div class="small-6 columns">is Required</div>
        <div class="small-6 columns">
          <input
            v-model="is_required"
            type="checkbox"
            @click="handleCheckboxChange($event, 'is_required')"
          />
        </div>
        <div class="small-6 columns">is Bonus</div>
        <div class="small-6 columns">
          <input
            v-model="is_bonus"
            type="checkbox"
            @click="handleCheckboxChange($event, 'is_bonus')"
          />
        </div>
      </div>

      <div class="small-12 columns">
        <div class="row question-type-container flex" style="text-align:center">
          <div class="small-2 columns link" @click="toggleReadingAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Reading"
              :class="readingAPI ? 'selected-icon' : ''"
              >insert_drive_file</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleVideoAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Video"
              :class="videoAPI ? 'selected-icon' : ''"
              >video_library</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleCodeAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Code"
              :class="codeAPI ? 'selected-icon' : ''"
              >code</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleGameAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Game"
              :class="gameAPI ? 'selected-icon' : ''"
              >games</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleBlocklyAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Blockly"
              :class="blocklyAPI ? 'selected-icon' : ''"
              >casino</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleMCQAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="MCQ"
              :class="MCQAPI ? 'selected-icon' : ''"
              >question_answer</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleInterviewAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Interview"
              :class="interviewAPI ? 'selected-icon' : ''"
              >camera_alt</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleWebAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Web"
              :class="webAPI ? 'selected-icon' : ''"
              >web</i
            >
          </div>
          <div class="small-2 columns link" @click="toggleProjectAPI">
            <i
              class="material-icons arrow-icon-ordering"
              title="Project Question"
              :class="projectQuestionAPI ? 'selected-icon' : ''"
              >add_task</i
            >
          </div>
        </div>
        <div>
          <h2>
            <span>Add </span> <span v-if="readingAPI"> Reading</span>
            <span v-if="videoAPI"> Video</span>
            <span v-if="codeAPI"> Code</span> <span v-if="gameAPI"> Game</span>
            <span v-if="blocklyAPI"> Blockly</span>
            <span v-if="MCQAPI"> MCQ</span> <span> Question</span>
          </h2>
        </div>
        <div v-if="MCQAPI">
          <div class="row mcq-stitch-form-container" />
          <multiselect
            v-model="mcqSortArray"
            :multiple="false"
            :options="getQuestionStitcherList"
            :searchable="true"
            :allow-empty="true"
            placeholder="Select MCQ"
            label="name"
            track-by="name"
          />

          <div>
            <button
              class="button-green border border-green bg-green text-white py-2 px-4 rounded-sm"
              @click="addMCQList"
            >
              Add MCQs
            </button>
          </div>
        </div>
        <QuestionAutoFill
          v-if="!MCQAPI"
          @questionIDSelected="updateSelectedQuestionID"
        />
        <button
          v-if="!MCQAPI"
          class="border border-green bg-green text-white py-2 px-4 rounded-sm"
          @click="addQuestionToTopic"
        >
          <span>Add </span> <span v-if="readingAPI"> Reading</span>
          <span v-if="videoAPI"> Video</span> <span v-if="codeAPI"> Code</span>
          <span v-if="MCQAPI"> MCQ</span> <span v-if="gameAPI">Game</span>
          <span v-if="blocklyAPI">Blockly</span> <span> Question</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
// import draggable from "vuedraggable"
import { mapGetters, mapActions } from "vuex"
import siteConfig from "@/utils/siteConfig"
import QuestionAutoFill from "@/components/courseEditors/courseEditorHelpers/QuestionAutoFill"

export default {
  components: { QuestionAutoFill, Multiselect },
  props: [
    "moduleName",
    "topicName",
    "isBonusState",
    "isRequiredState",
    "selectedQuestionApi",
  ],
  data() {
    return {
      readingAPI: false,
      videoAPI: false,
      gameAPI: false,
      codeAPI: false,
      blocklyAPI: false,
      MCQAPI: false,
      interviewAPI: false,
      webAPI: false,
      projectQuestionAPI: false,
      // /questions
      currentSelectedQuestionToAdd: undefined,
      // /////////////
      mcqSortArray: [],
      mcqStitchedGroupName: "",
      mcqStitchedIs_required: false,
      is_required: true,
      is_bonus: false,
      /* question params for requests */
      questionType: undefined,
    }
  },
  computed: {
    ...mapGetters("module", [
      "getCurrentEditingTopic",
      "getCurrentModuleID",
      "getQuestionStitcherList",
    ]),
  },
  created() {
    // restore previously selected state
    if (this.selectedQuestionApi) {
      this[this.selectedQuestionApi] = true
    }
    this.is_required = this.isRequiredState
    this.is_bonus = this.isBonusState
  },
  mounted() {
    this.$nextTick(() => {
      /* focus dropdown input */
      const input = this.$el.querySelector(".multiselect__input")
      if (input) input.focus()
    })
  },
  methods: {
    ...mapActions("module", [
      "SET_QUESTION_STITCHER_LIST",
      "LOAD_CURRENT_COURSES_EDITING_STATE",
    ]),
    updateSelectedQuestionApi(apiName) {
      this.$emit("UPDATE_SELECTED_QUESTION_API", apiName)
    },
    handleCheckboxChange(e, name) {
      const payload = {}
      payload[name] = e.target.checked // the key is dynamic
      this.$emit("CHECKBOX_STATE_CHANGE", payload)
    },
    addMCQList() {
      const mcqStitchedID = this.mcqSortArray.id
      this.currentSelectedQuestionToAdd = mcqStitchedID
      this.addQuestionToTopic()
    },

    addQuestionToTopic() {
      for (let i = 0; i < this.getQuestionStitcherList.length; i++) {
        if (
          this.getQuestionStitcherList[i].id ===
          this.currentSelectedQuestionToAdd
        ) {
          const obj = {
            id: this.currentSelectedQuestionToAdd,
            is_required: this.is_required,
            is_bonus: this.is_bonus,
            questionObject: this.getQuestionStitcherList[i],
          }

          this.$emit("QUESTION_ID_ADDED", obj)
          return
        }
      }
    },
    updateSelectedQuestionID(item) {
      this.currentSelectedQuestionToAdd = item.id
    },
    resetAPIs() {
      this.readingAPI = false
      this.videoAPI = false
      this.codeAPI = false
      this.MCQAPI = false
      this.gameAPI = false
      this.blocklyAPI = false
      this.interviewAPI = false
      this.webAPI = false
      this.SET_QUESTION_STITCHER_LIST([])
    },
    toggleReadingAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.readingAPI = !this.readingAPI
      this.updateSelectedQuestionApi("readingAPI")
      this.updateQuestionList()
    },
    toggleVideoAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.videoAPI = !this.videoAPI
      this.updateSelectedQuestionApi("videoAPI")
      this.updateQuestionList()
    },
    toggleCodeAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.codeAPI = !this.codeAPI
      this.updateSelectedQuestionApi("codeAPI")
      this.updateQuestionList()
    },
    toggleMCQAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.MCQAPI = !this.MCQAPI
      this.updateSelectedQuestionApi("MCQAPI")
      this.updateQuestionList()
    },
    toggleGameAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.gameAPI = !this.gameAPI
      this.updateSelectedQuestionApi("gameAPI")
      this.updateQuestionList()
    },
    toggleBlocklyAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.blocklyAPI = !this.blocklyAPI
      this.updateSelectedQuestionApi("blocklyAPI")
      this.updateQuestionList()
    },
    toggleInterviewAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.interviewAPI = !this.interviewAPI
      this.updateSelectedQuestionApi("interviewAPI")
      this.updateQuestionList()
    },
    toggleWebAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.webAPI = !this.webAPI
      this.updateSelectedQuestionApi("webAPI")
      this.updateQuestionList()
    },
    toggleProjectAPI() {
      this.mcqSortArray = []
      this.resetAPIs()
      this.projectQuestionAPI = !this.projectQuestionAPI
      this.updateSelectedQuestionApi("projectQuestionAPI")
      this.updateQuestionList()
    },
    updateQuestionList() {
      if (this.readingAPI) {
        this.questionType = 3
      } else if (this.gameAPI) {
        this.questionType = 5
      } else if (this.codeAPI) {
        this.questionType = 6
      } else if (this.videoAPI) {
        this.questionType = 4
      } else if (this.MCQAPI) {
        this.questionType = 0
      } else if (this.interviewAPI) {
        this.questionType = 7
      } else if (this.blocklyAPI) {
        this.questionType = 8
      } else if (this.webAPI) {
        this.questionType = 9
      } else if (this.projectQuestionAPI) {
        this.questionType = 12
      }
      this.fetchQuestions()
    },
    fetchQuestions() {
      const loader = this.$loading.show()
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/questions?pagination=false&search_by_type=${this.questionType}&fields=id,slug,name,reading_time,type,points,time_allocated,list`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          loader.hide()
          let response
          if (this.questionType === 0) {
            // this is for MCQ questions
            response = res.data.items.filter(item => {
              item.list = JSON.parse(item.list)
              if (item.list.has && item.list.has === "multiple") {
                return true
              }
              return false
            })
          } else {
            response = res.data.items
          }
          this.SET_QUESTION_STITCHER_LIST(response)
        })
        .catch(() => {
          loader.hide()
        })
    },
  },
}
</script>

<style soped>
.material-icons-selected {
  border: 1px solid green;
}

.selected-icon {
  border-radius: 2px;
  color: white;
  background: green;
}

.mcq-stitch-form-container {
  margin-bottom: 20px;
}
.draggable-mcq-list-item {
  padding: 4px 50px;
  border: 1px solid #b5b5b5;
}
</style>
